module.exports = __webpack_public_path__ + "img/ex-chat.3be5fdc7.svg";